import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcBaggage(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 8a2.75 2.75 0 0 1 2.75-2.75h8.5A2.75 2.75 0 0 1 19 8v11a2.75 2.75 0 0 1-2.75 2.75h-8.5A2.75 2.75 0 0 1 5 19zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v11c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20.25a.75.75 0 0 1 .75.75v1.25a.75.75 0 0 1-1.5 0V21a.75.75 0 0 1 .75-.75M16 20.25a.75.75 0 0 1 .75.75v1.25a.75.75 0 0 1-1.5 0V21a.75.75 0 0 1 .75-.75M14 8.75a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0v-8a.75.75 0 0 1 .75-.75M10 8.75a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0v-8a.75.75 0 0 1 .75-.75M10.5 2.75a.25.25 0 0 0-.25.25v3h-1.5V3c0-.966.784-1.75 1.75-1.75h3c.966 0 1.75.784 1.75 1.75v3h-1.5V3a.25.25 0 0 0-.25-.25z"
  })));
}
var IcBaggage = createNolIcon(/*#__PURE__*/forwardRef(SvgIcBaggage));

export { IcBaggage as I };
